module.exports = __webpack_public_path__ + "img/6521d05.jpg";